var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVivawallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 913 148.7",
    style: {
      enableBackground: "new 0 0 913 148.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#20253A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.8,141.1c-10,0-19.1-5.7-24.8-15.4c-5.8,9.7-14.9,15.4-24.8,15.4c-0.1,0-0.1,0-0.2,0 c-10.9-0.1-20.6-6.9-26.2-18.4v-0.1L5,31.6L59.6,6.2l39.3,83.4l38.9-83.4l54.6,25.4l-42.2,91.1c-5.5,11.4-15.3,18.3-26.2,18.4 C123.9,141.1,123.9,141.1,123.8,141.1 M111.5,116.3c3,5.9,7.5,9.3,12.3,9.3h0.1c4.9,0,9.4-3.5,12.3-9.6l35.6-76.9l-26.5-12.3 l-37.8,81L111.5,116.3z M61.8,116c2.9,6.1,7.4,9.6,12.3,9.6c0,0,0,0,0.1,0c4.8,0,9.3-3.4,12.3-9.3l3.9-8.4L52.1,26.8L25.7,39.1 L61.8,116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.2,123.9c8.1,0,12.2-6.6,14.2-11.2l20-50.8l-15.9-5.8L258.2,107l-18.3-50.8L224,61.9l20,50.8 C246.1,117.3,250.1,123.9,258.2,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.1,123.9c8.1,0,12.2-6.6,14.2-11.2l20-50.8l-15.9-5.8L369.1,107l-18.3-50.8L334.9,62l20,50.8 C356.9,117.3,361,123.9,369.1,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476,122.2h-16.4v-7.3c-4.3,5.4-10.8,9.1-19.9,9.1c-18.3,0-32.2-15-32.2-35s13.9-35,32.2-35 c9.1,0,15.5,3.7,19.9,9.1v-7.4H476V122.2z M423.9,88.9c0,10.7,7,19.3,18.1,19.3c10.8,0,18.1-8.3,18.1-19.3 c0-11.1-7.3-19.3-18.1-19.3C431,69.6,423.9,78.2,423.9,88.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M840,88.8c0,2.1-0.1,4.5-0.3,6h-48.1c1.9,9.6,9.6,14.2,18.1,14.2c7.2,0,12.2-2.2,17-6.2l10.3,10.9 c-7.5,6.9-17.2,10.1-28.4,10.1c-20.4,0-34.5-13.9-34.5-34.8c0-21,13.7-35.2,33.6-35.2C826.8,53.9,839.9,68.1,840,88.8 M791.3,83.2 H823c-1-8.9-7.3-14.8-15.5-14.8C798.5,68.4,791.9,75,791.3,83.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M902.4,71.6h-25.7v24.3c0,8.3,3,12.1,11.4,12.1c4.3,0,9.3-2.7,12.9-4.9l6.3,13.7c-5.8,4-12.6,7-22,7 c-16.5,0-24.9-9.3-24.9-26.6V71.6h-12.8V56.1h12.8V35.9h16.3v20.2h25.7V71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M601.8,56.2L583.5,107L567,61.4c-1.6-4.4-5.3-7.5-10-7.5s-8.4,3.1-10,7.5L530.7,107l-18.3-50.8L496.5,62 l20.1,50.8c2.1,4.6,6.1,11.2,14.2,11.2c8.1,0,12.1-6.6,14.2-11.2L557.1,82l12.1,30.7c2.1,4.6,6.1,11.2,14.2,11.2 c8.1,0,12.2-6.6,14.2-11.2l20.1-50.8L601.8,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M689.9,122.2h-16.4v-7.3c-4.3,5.4-10.8,9.1-19.9,9.1c-18.3,0-32.2-15-32.2-35s13.9-35,32.2-35 c9.1,0,15.5,3.7,19.9,9.1v-7.4h16.4V122.2z M637.8,88.9c0,10.7,7,19.3,18.1,19.3c10.8,0,18.1-8.3,18.1-19.3 c0-11.1-7.3-19.3-18.1-19.3C644.8,69.6,637.8,78.2,637.8,88.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.4,
    y: 23.3,
    className: "st0",
    width: 16.2,
    height: 99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 742.8,
    y: 23.3,
    className: "st0",
    width: 16.2,
    height: 99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 55.7,
    className: "st0",
    width: 16.3,
    height: 66.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.9,33.3c0,5.9-4.6,10.4-10.4,10.4c-5.9,0-10.4-4.5-10.4-10.4s4.5-10.5,10.4-10.5 C319.3,22.8,323.9,27.4,323.9,33.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivawallet);
export default __webpack_public_path__ + "static/media/vivawallet.8ce85e44c6debce0d2fb7b33250e67b6.svg";
export { ForwardRef as ReactComponent };